import ko from "knockout";
import { CustomElement } from "../../../core/CustomElement";

/**
 * Date picker vm
 */
export default class DatePickerVM {
  container: CustomElement = null;
  // dateFormat: KnockoutObservable<string> = ko.observable("YYYY-MM-DD");
  dateSelected: KnockoutObservable<string> = ko.observable("");
  dateSelectedFormated: KnockoutComputed<string> = ko.computed(() => {
    return this.dateSelected();
  });

  dateSelectedSub: KnockoutSubscription = null;

  constructor(element: CustomElement) {
    this.container = element;
  }

  // eslint-disable-next-line
  subscribeToValue(fn: Function): void {
    if (this.dateSelectedSub) {
      this.dateSelectedSub.dispose();
    }

    this.dateSelectedSub = this.dateSelected.subscribe((newVal) => {
      fn.call(this, newVal);
    });
  }
}
